import React from 'react';
import { useNavigate } from 'react-router-dom';

function PaymentFailed() {
    const navigate = useNavigate();
    const handleNavigate = () => {
navigate(-1)
    }
  return (
    <div style={styles.container}>
      <img 
        src="./PaymentFailed.svg" 
        alt="Payment Failed" 
        style={styles.image} 
      />
      <h1 style={styles.heading}>Payment Failed</h1>
      <p style={styles.message}>
        Unfortunately, your payment could not be processed. Please try again or contact support for assistance.
      </p>
      <button style={styles.button} onClick={() => handleNavigate()}>
        Try Again
      </button>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    padding: '20px',
    backgroundColor: '#f9f9f9',
    textAlign: 'center',
  },
  image: {
    width: '30%',
    height: 'auto', 
    marginBottom: '20px',
  },
  heading: {
    fontSize: '24px',
    fontWeight: 'bold',
    color: '#f44336', // Red color to indicate failure
    marginBottom: '10px',
  },
  message: {
    fontSize: '16px',
    color: '#555',
    textAlign: 'center',
    maxWidth: '400px',
    marginBottom: '20px',
  },
  button: {
    backgroundColor: '#f44336', // Red color for retry button
    color: '#fff',
    border: 'none',
    padding: '10px 20px',
    borderRadius: '5px',
    cursor: 'pointer',
    fontSize: '16px',
  },
};

export default PaymentFailed;
